<template>
  <span
    class="workbench-icon"
    :style="{
      '--workbench-icon': `url(/assets/images/workbench/icons/${name}.svg)`,
      width: `${size}px`,
      height: `${size}px`,
    }"
    aria-hidden="true"
  />
</template>

<script setup lang="ts">
withDefaults(defineProps<{
  name: string
  size?: number
}>(), {
  size: 16,
})
</script>

<style scoped>
.workbench-icon {
  display: inline-block;
  flex: 0 0 auto;
  background: currentColor;
  mask: var(--workbench-icon) center / contain no-repeat;
  -webkit-mask: var(--workbench-icon) center / contain no-repeat;
}
</style>
